
import searchAPI from '../api/search';

export default {
  name: 'SearchBlock',

  data() {
    return {
      opened: false,
      form: {
        q: null,
      },
      results: [],
      activeFilters: [],
      filterOptions: [],
    };
  },

  computed: {
    filteredResultsList() {
      // If no filters are active, show all results
      if (this.activeFilters.length === 0) {
        return this.results;
      }
      return this.results.filter((item) => {
        const itemType = item?.model?.type;
        return itemType && this.activeFilters.includes(itemType);
      });
    },
  },

  mounted() {
    this.$nuxt.$on('search', this.searchNow);
    this.$nuxt.$on('searchClose', this.closePanel);
  },

  methods: {
    async searchNow(query) {
      try {
        this.form.q = query;
        const rsp = await searchAPI.search({ params: this.form });
        
        // Defensive check for response structure
        if (rsp && rsp.data && rsp.data.data) {
          this.results = rsp.data.data;
        } else {
          this.results = [];
        }
        
        this.opened = true;
        this.buildFilterGroups();
      } catch (error) {
        console.error('Search error:', error);
        this.results = [];
        this.opened = true;
        this.buildFilterGroups();
      }
    },

    closePanel() {
      this.opened = false;
    },

    buildFilterGroups() {
      let options = this.results
        .map((item) => item?.model?.type)
        .filter(Boolean); // Remove undefined/null values
      options = [...new Set(options)];
      this.filterOptions = options;
      this.activeFilters = options;
    },
  },
};
